export default __webpack_public_path__ + "static/media/home_ghibli_totoro_face.cba777a5.jpg";